import type { ChronologyResolution } from './chronology.js';
import type { NormalizedChart } from './domain.js';
import type { GeneratedInterpretation } from './interpretation.js';
import { buildPrintPacket, type PrintPacket } from './printPresentation.js';
import type { ResultActionId } from './resultActionsPresentation.js';

export type ProductionPrintActionId = Extract<
  ResultActionId,
  'print_redacted_summary' | 'print_with_evidence' | 'print_with_full_birth'
>;

export function buildProductionPrintPacket(
  action: ProductionPrintActionId,
  chart: NormalizedChart,
  interpretations: readonly GeneratedInterpretation[],
  chronology?: Readonly<{ birth: ChronologyResolution; target?: ChronologyResolution }>,
): PrintPacket {
  if (action === 'print_redacted_summary') {
    return buildPrintPacket(chart, interpretations, 'redacted', 'summary', chronology);
  }
  if (action === 'print_with_evidence') {
    return buildPrintPacket(chart, interpretations, 'redacted', 'evidence', chronology);
  }
  if (action === 'print_with_full_birth') {
    return buildPrintPacket(chart, interpretations, 'full', 'summary', chronology);
  }
  throw new Error(`Unsupported production print action ${String(action)}`);
}
